export const SUBMIT_DEVICE = (state, userDevice) => {
  state.userDevice = userDevice;
};

export const SUBMIT_PLATFORM_TYPE = (state, type) => {
  state.platformType = type;
};

export const SUBMIT_DEVICE_IOS_VERSION = (state, IOSVersion) => {
  state.IOSDeviceVersion = IOSVersion;
};

export const SUBMIT_IS_IPHONE = (state, isIPhone) => {
  state.isIPhone = isIPhone;
};
